export { default } from './Video';
export type { Props, Props as VideoProps } from './Video';
